
import { useState } from 'react';

export const useSlugGeneration = () => {
  const [isGenerating, setIsGenerating] = useState(false);

  const generateSlugFromTitle = async (title?: string): Promise<string | null> => {
    setIsGenerating(true);
    try {
      if (!title) return null;

      // Generate slug from title
      const slug = title
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .trim()
        .replace(/^-+|-+$/g, ''); // Remove leading/trailing dashes

      return slug || null;
    } catch (error) {
      console.error('Error generating slug:', error);
      return null;
    } finally {
      setIsGenerating(false);
    }
  };

  const handleTitleChange = async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
    const title = e.target.value;
    if (title) {
      // Generate slug from title
      const slug = title
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .trim();
      
      // You can add logic here to check if slug exists and modify if needed
      console.log('Generated slug:', slug);
    }
  };

  return {
    generateSlugFromTitle,
    handleTitleChange,
    isGenerating
  };
};
